<template>
  
    <VehicleConfigurationNav v-if="!loading" @usage="setUsage" />
  
    <StepsToCalculateNav v-if="!loading" :fuelCost="costElectric" :equipment="costEquipment" :otherCost="costOther" :active="2" :usage="currentUsage" />

    <div class="container-fluid" v-if="!loading">
        <div class="row my-5">
            <div class="col-sm-6 vehicle-card-col">
                <VehicleCard :vehicle="vehicleInfo" />
            </div>
            <div class="col-sm-6 text-left vehicle-input-col">
                <p class="heading-3">Other Cost Input <button class="info-toggle font-bold" data-toggle="modal" data-target="#info-modal-other">?</button></p>
                <div class="d-none">
                    <button @click="currencyToggle()">currency toggle temp</button>
                    <div id="testing">{{this.currentCurrency}}</div>
                </div>
                <div class="input-block">

                    <!-- Maintenance Annual Cost -->
                    <div class="form-group mt-5">
                        <label for="electricMaintenanceCost" class="w-100">Maintenance and Tires Annual Cost ($) <button class="info-toggle font-bold mt-0" data-toggle="modal" data-target="#info-modal-maintenance">?</button></label>
                        <input type="text" class="range-output output-text" v-model="maintenanceCostFormatted" @input="formatInputMaintenanceCost(); calculateTotals(); independentCostAdjustment()" @change="trackMaintenance(maintenanceCost)">
                        <input type="number" id="electricMaintenanceCostOutput" class="range-output d-none" min="0" max="100000" v-model="maintenanceCost">
                        <input class="form-control-range" type="range" id="electricMaintenanceCost" name="electricMaintenanceCost" min="0" max="100000" v-model.number="maintenanceCost" @input="formatInputFromSliderMaintenanceCost(); calculateTotals(); independentCostAdjustment()" @change="trackMaintenance(maintenanceCost)">
                    </div>
                    
                    <!-- Insurance Annual Cost -->
                    <div class="form-group mt-5">
                        <label for="electricInsuranceCost" class="w-100">Insurance Annual Cost ($)</label>
                        <input type="text" class="range-output output-text" v-model="insuranceCostFormatted" @input="formatInputInsuranceCost(); calculateTotals()" @change="trackInsurance(insuranceCost)">
                        <input type="number" id="electricInsuranceCostOutput" class="range-output d-none" min="0" max="100000" v-model="insuranceCost">
                        <input class="form-control-range" type="range" id="electricInsuranceCost" name="electricInsuranceCost" min="0" max="100000" v-model="insuranceCost" @input="formatInputFromSliderInsuranceCost(); calculateTotals()" @change="trackInsurance(insuranceCost)"> 
                    </div>

                    <!-- Taxes Annual Cost -->
                    <div class="form-group mt-5">
                        <label for="electricTaxesCost" class="w-100">Taxes Annual Cost ($)</label>
                        <input type="text" class="range-output output-text" v-model="taxesCostFormatted" @input="formatInputTaxesCost(); calculateTotals()" @change="trackTaxes(taxesCost)">
                        <input type="number" id="electricTaxesCostOutput" class="range-output d-none" min="0" max="100000" v-model="taxesCost">
                        <input class="form-control-range" type="range" id="electricTaxesCost" name="electricTaxesCost" min="0" max="100000" v-model="taxesCost" @input="formatInputFromSliderTaxesCost(); calculateTotals()" @change="trackTaxes(taxesCost)"> 
                    </div>

                    <!-- Tolls Annual Cost -->
                    <div class="form-group mt-5">
                        <label for="electricTollsCost" class="w-100">Tolls Annual Cost ($)</label>
                        <input type="text" class="range-output output-text" v-model="tollsCostFormatted" @input="formatInputTollsCost(); calculateTotals()" @change="trackTolls(tollsCost)">
                        <input type="number" id="electricTollsCostOutput" class="range-output d-none" min="0" max="100000" v-model="tollsCost">
                        <input class="form-control-range" type="range" id="electricTollsCost" name="electricTollsCost" min="0" max="100000" v-model="tollsCost" @input="formatInputFromSliderTollsCost(); calculateTotals()" @change="trackTolls(tollsCost)"> 
                    </div>

                    <!-- Estimated Driver Annual Cost -->
                    <div class="form-group my-5">
                        <label for="electricDriverCost" class="w-100">Estimated Driver Annual Cost ($)</label>
                        <input type="text" class="range-output output-text" v-model="driverCostFormatted" @input="formatInputDriverCost(); calculateTotals()" @change="trackDriver(driverCost)">
                        <input type="number" id="electricDriverCostOutput" class="range-output d-none" min="0" max="100000" v-model="driverCost">
                        <input class="form-control-range" type="range" id="electricDriverCost" name="electricDriverCost" min="0" max="100000" v-model="driverCost" @input="formatInputFromSliderDriverCost(); calculateTotals()" @change="trackDriver(driverCost)"> 
                    </div>

                </div>

                <div class="text-center next-link position-relative">
                    <a href="#" class="big-link heading-2 text-center" data-toggle="modal" data-target="#summary-electric" @click="trackViewSummary()">View Full Summary <img :src="`${imagePath}/arrow-white.png`" alt=""></a>
                </div>
            </div>
        </div>
    </div>

    <div class="container-footer" v-if="!loading">
        <div class="container-fluid">
            <div class="row py-4">
                <div class="col-sm-12">
                    <div class="totals-container d-flex w-100 justify-content-between">
                        <div class="totals-item">
                            <p class="text-uppercase">Other Costs Total</p>
                            <div class="d-flex justify-content-between">
                            
                                <div class="mr-5">
                                    <p v-if="currentUsage == 'miles'" class="mb-0" id="costPerMileOuput" v-html="formatPrice(costOther['cost-per-mile'] * currencyExchange)"></p>
                                    <p v-if="currentUsage == 'hours'" class="mb-0" id="costPerMileOuput" v-html="formatPrice(costOther['cost-per-hour'] * currencyExchange)"></p>
                                    <small>Total Cost Per {{ currentUsage == 'miles' ? 'Mile' : 'Hour' }}</small>
                                </div>
                    
                                <div class="">
                                    <p v-if="currentUsage == 'miles'" class="mb-0" id="annualFuelCostOuput" v-html="formatPrice(costOther['annual-cost'] * currencyExchange, 0)"></p>
                                    <p v-if="currentUsage == 'hours'" class="mb-0" id="annualFuelCostOuput" v-html="formatPrice(costOther['annual-cost-hourly'] * currencyExchange, 0)"></p>
                                    <small>Total Annual Cost</small>
                                </div>
                    
                            </div>
                        </div>
                        
                        <ElectricFooter :fuelCost="costElectric" :equipmentCost="costEquipment" :otherCost="costOther" :usage="currentUsage" />

                        <ElectricSummaryModal :vehicle="vehicleInfo" :fuelCost="costElectric" :equipment="costEquipment" :otherCost="costOther" :usage="currentUsage" />

                        <div id="info-modal-other" class="modal-summary modal-info modal fade" tabindex="-1">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header py-2">
                                        <button type="button" class="close ml-auto" data-dismiss="modal" aria-label="Close">
                                        <span class="material-icons" aria-hidden="true">clear</span>
                                        </button>
                                    </div>
                                    <div class="modal-body">
                                        <p class="mb-0">
                                            Default values for Other Costs are representative of average marginal costs published in the Operational Costs of Trucking; 2020 Update, by ATRI (American Transportation Research Institute).
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="info-modal-maintenance" class="modal-summary modal-info modal fade" tabindex="-1">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header py-2">
                                        <button type="button" class="close ml-auto" data-dismiss="modal" aria-label="Close">
                                        <span class="material-icons" aria-hidden="true">clear</span>
                                        </button>
                                    </div>
                                    <div class="modal-body">
                                        <p class="mb-0">
                                            Default values for Electric Vehicle Maintenance costs are representative of 40% maintenance costs savings over diesel vehicles, based upon initial industry estimates.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import StepsToCalculateNav from "@/components/StepsToCalculateNav.vue";
    import VehicleConfigurationNav from "@/components/VehicleConfigurationNav.vue";

    import VehicleCard from "../components/VehicleCard"
    import ElectricFooter from "../components/ElectricFooter"
    import ElectricSummaryModal from "../components/ElectricSummaryModal"

    export default {
        name: 'ElectricOtherCosts',
        components: {
            VehicleCard,
            ElectricFooter,
            StepsToCalculateNav,
            VehicleConfigurationNav,
            ElectricSummaryModal
        },
        data() {
            return {
                currentUsage: 'miles', // set as default
                vehicleInfo: [],
                costElectric: [],
                costEquipment: [],
                costOther: [],
                costOtherDiesel: null,
                isMaintCostChangeClick: false,
                isMaintCostChange: false,
                dMaintenanceCost: 0,
                dMaintenanceCostHourly: 0,

                // Setting defaults for model
                maintenanceCost: 0,
                maintenanceCostFormatted: 0,
                insuranceCost: 0,
                insuranceCostFormatted: 0,
                taxesCost: 0,
                taxesCostFormatted: 0,
                tollsCost: 0,
                tollsCostFormatted: 0,
                driverCost: 0,
                driverCostFormatted: 0,
                maintenanceCostHourly: 0,
                insuranceCostHourly: 0,
                taxesCostHourly: 0,
                tollsCostHourly: 0,
                driverCostHourly: 0,
                currencyType: '',
                currrencyCoversion: 0,
                currencyExchange: 1,
                modified: false,
                loading: true,
                imagePath: process.env.VUE_APP_ASSET_LOCATION
            }
        },
        mounted() {

            // Set currency
            this.currencyType = sessionStorage.getItem('currency')
            this.currencyExchange = this.currencyType == 'canada' ? Number(localStorage.getItem('USDtoCAD')) : 1

            // Grab vehicle info from storage and begin filling in props
            // vehicleInfoHidden is for setting equivalent values for diesel and electric
            this.vehicleInfo = JSON.parse(localStorage.getItem('calculatorVehicleElectric'))
            this.vehicleInfoHidden = JSON.parse(localStorage.getItem('calculatorVehicleDiesel'))

            this.costElectric = JSON.parse(sessionStorage.getItem('electricFuelCost'))
            this.costEquipment = JSON.parse(sessionStorage.getItem('electricEquipmentCost'))
            this.costOther = JSON.parse(sessionStorage.getItem('electricOtherCost'))
            this.costOtherDiesel = JSON.parse(sessionStorage.getItem('dieselOtherCost'))
            this.currencyConversion = this.currencyExchange
            this.modified = this.costOther['modified']
            
            // If US from CA
            if (sessionStorage.getItem('fromCanada') != null && sessionStorage.getItem('fromCanada') == 'true') {
                if ( !this.costOther.modified && !this.costOtherDiesel['modified'] ) {
                    // If nothing has been touched
                    this.maintenanceCost = (this.vehicleInfo.fuel.mileage * this.vehicleInfo.maintenance.costPerMile) / this.currencyConversion
                }else if ( !this.costOther.modified && this.costOtherDiesel['modified'] ) {
                    // if nothing on electric has been touched but diesel has been
                    this.maintenanceCost = (this.costOtherDiesel['cost-maintenance'] * 0.6) / this.currencyConversion
                }else {
                    // If both sides have been touched
                    this.maintenanceCost = this.costOther['cost-maintenance'] / this.currencyConversion
                }
                this.insuranceCost = this.costOther.modified == false ? (this.vehicleInfo.fuel.mileage * this.vehicleInfo.insurance.costPerMile) / this.currencyConversion : this.costOther['cost-insurance'] / this.currencyConversion
                this.taxesCost = this.costOther.modified == false ? (this.vehicleInfo.fuel.mileage * this.vehicleInfo.taxes.costPerMile) / this.currencyConversion : this.costOther['cost-taxes'] / this.currencyConversion
                this.tollsCost = this.costOther.modified == false ? (this.vehicleInfo.fuel.mileage * this.vehicleInfo.tolls.costPerMile) / this.currencyConversion : this.costOther['cost-tolls'] / this.currencyConversion
                this.driverCost = this.costOther.modified == false ? (this.vehicleInfo.fuel.mileage * this.vehicleInfo.driver.driverWagePerMile) / this.currencyConversion : this.costOther['cost-driver'] / this.currencyConversion
            }

            // If CA from US
            if (sessionStorage.getItem('fromCanada') != null && sessionStorage.getItem('fromCanada') == 'false') {
                if ( !this.costOther.modified && !this.costOtherDiesel['modified'] ) {
                    // If nothing has been touched
                    this.maintenanceCost = (this.vehicleInfo.fuel.mileage * this.vehicleInfo.maintenance.costPerMile) * this.currencyConversion
                }else if ( !this.costOther.modified && this.costOtherDiesel['modified'] ) {
                    // if nothing on electric has been touched but diesel has been
                    this.maintenanceCost = (this.costOtherDiesel['cost-maintenance'] * 0.6) * this.currencyConversion
                }else {
                    // If both sides have been touched
                    this.maintenanceCost = this.costOther['cost-maintenance'] * this.currencyConversion
                }
                this.insuranceCost = this.costOther.modified == false ? (this.vehicleInfo.fuel.mileage * this.vehicleInfo.insurance.costPerMile) * this.currencyConversion : this.costOther['cost-insurance'] * this.currencyConversion
                this.taxesCost = this.costOther.modified == false ? (this.vehicleInfo.fuel.mileage * this.vehicleInfo.taxes.costPerMile) * this.currencyConversion : this.costOther['cost-taxes'] * this.currencyConversion
                this.tollsCost = this.costOther.modified == false ? (this.vehicleInfo.fuel.mileage * this.vehicleInfo.tolls.costPerMile) * this.currencyConversion : this.costOther['cost-tolls'] * this.currencyConversion
                this.driverCost = this.costOther.modified == false ? (this.vehicleInfo.fuel.mileage * this.vehicleInfo.driver.driverWagePerMile) * this.currencyConversion : this.costOther['cost-driver'] * this.currencyConversion
            }

            if (sessionStorage.getItem('fromCanada') == null) {
                if ( !this.costOther.modified && !this.costOtherDiesel['modified'] ) {
                    // If nothing has been touched
                    this.maintenanceCost = (this.vehicleInfo.fuel.mileage * this.vehicleInfo.maintenance.costPerMile) / this.currencyConversion
                }else if ( !this.costOther.modified && this.costOtherDiesel['modified'] ) {
                    // if nothing on electric has been touched but diesel has been
                    this.maintenanceCost = (this.costOtherDiesel['cost-maintenance'] * 0.6) / this.currencyConversion
                }else {
                    // If both sides have been touched
                    this.maintenanceCost = this.costOther['cost-maintenance'] / this.currencyConversion
                }
                this.insuranceCost = this.costOther.modified == false ? this.vehicleInfo.fuel.mileage * this.vehicleInfo.insurance.costPerMile : this.costOther['cost-insurance']
                this.taxesCost = this.costOther.modified == false ? this.vehicleInfo.fuel.mileage * this.vehicleInfo.taxes.costPerMile : this.costOther['cost-taxes']
                this.tollsCost = this.costOther.modified == false ? this.vehicleInfo.fuel.mileage * this.vehicleInfo.tolls.costPerMile : this.costOther['cost-tolls']
                this.driverCost = this.costOther.modified == false ? this.vehicleInfo.fuel.mileage * this.vehicleInfo.driver.driverWagePerMile : this.costOther['cost-driver']
            }

            
            this.maintenanceCostFormatted = Math.round(this.maintenanceCost).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            this.insuranceCostFormatted = Math.round(this.insuranceCost).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            this.taxesCostFormatted = Math.round(this.taxesCost).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            this.tollsCostFormatted = Math.round(this.tollsCost).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            this.driverCostFormatted = Math.round(this.driverCost).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            this.maintenanceCostHourly = this.vehicleInfo.fuel.mileage * this.vehicleInfo.maintenance.costPerHour
            this.insuranceCostHourly = this.costOther['cost-insurance-hourly']
            this.taxesCostHourly = this.costOther['cost-taxes-hourly']
            this.tollsCostHourly = this.costOther['cost-tolls-hourly']
            this.driverCostHourly = this.costOther['cost-driver-hourly']

            this.currentCurrency = sessionStorage.getItem('currency')
            this.usToCa = 1.27
            this.gallonToLitre = 3.79
            this.milesToKm = 1.61

            //!get variable for retaining dieselMaintenceCost adjustment flag
            this.isMaintCostChange = this.costOther['isMaintCostChange'];
            this.dCostMaintenance = this.costOtherDiesel['cost-maintenance'];
            this.dCostMaintenanceHourly = this.costOtherDiesel['cost-maintenance-hourly'];

            if(this.isMaintCostChange == false) {
                this.dMaintenanceCost = 0;
                this.dMaintenanceCostHourly = 0;
            } else {
                this.dMaintenanceCost = this.costOther['d-cost-maintenance']
                this.dMaintenanceCostHourly = this.costOther['d-cost-maintenance-hourly']
            }
            this.calculateTotals()

            this.loading = false

            // Tracking
            window.gtag('event', 'page_view', {
                page_title: 'Cost Calculator - Diesel Other Cost',
                page_location: '/diesel/other-costs'
            })
        },

        watch: {
            maintenanceCostFormatted: function(newValue) {
                const result = newValue.replace(/[^0-9.]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.$nextTick(() => {
                    this.maintenanceCostFormatted = result
                    this.modified = true
                })
            },
            insuranceCostFormatted: function(newValue) {
                const result = newValue.replace(/[^0-9.]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.$nextTick(() => {
                    this.insuranceCostFormatted = result
                    this.modified = true
                })
            },
            taxesCostFormatted: function(newValue) {
                const result = newValue.replace(/[^0-9.]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.$nextTick(() => {
                    this.taxesCostFormatted = result
                    this.modified = true
                })
            },
            tollsCostFormatted: function(newValue) {
                const result = newValue.replace(/[^0-9.]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.$nextTick(() => {
                    this.tollsCostFormatted = result
                    this.modified = true
                })
            },
            driverCostFormatted: function(newValue) {
                const result = newValue.replace(/[^0-9.]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.$nextTick(() => {
                    this.driverCostFormatted = result
                    this.modified = true
                })
            }
        },

        methods: {
            calculateTotals() {
                
                // This Block of variables allows values to persist after going back
                // or after changing from Diesel Electric & vice-versa
                this.vehicleInfo['maintenance']['costPerHour'] = (this.maintenanceCost / Number(this.vehicleInfo.fuel.hours)).toFixed(2)
                this.vehicleInfoHidden['maintenance']['costPerHour'] = (this.maintenanceCost / Number(this.vehicleInfo.fuel.hours)).toFixed(2)
                this.maintenanceCostHourly = (this.maintenanceCost / Number(this.vehicleInfo.fuel.hours)).toFixed(2)

                this.vehicleInfo['insurance']['costPerHour'] = (this.insuranceCost / Number(this.vehicleInfo.fuel.hours)).toFixed(2)
                this.vehicleInfoHidden['insurance']['costPerHour'] = (this.insuranceCost / Number(this.vehicleInfo.fuel.hours)).toFixed(2)
                this.insuranceCostHourly = (this.insuranceCost / Number(this.vehicleInfo.fuel.hours)).toFixed(2)

                this.vehicleInfo['taxes']['costPerHour'] = (this.taxesCost / Number(this.vehicleInfo.fuel.hours)).toFixed(2)
                this.vehicleInfoHidden['taxes']['costPerHour'] = (this.taxesCost / Number(this.vehicleInfo.fuel.hours)).toFixed(2)
                this.taxesCostHourly = (this.taxesCost / Number(this.vehicleInfo.fuel.hours)).toFixed(2)

                this.vehicleInfo['tolls']['costPerHour'] = (this.tollsCost / Number(this.vehicleInfo.fuel.hours)).toFixed(2)
                this.vehicleInfoHidden['tolls']['costPerHour'] = (this.tollsCost / Number(this.vehicleInfo.fuel.hours)).toFixed(2)
                this.tollsCostHourly = (this.tollsCost / Number(this.vehicleInfo.fuel.hours)).toFixed(2)

                this.vehicleInfo['driver']['costPerHour'] = (this.driverCost / Number(this.vehicleInfo.fuel.hours)).toFixed(2)
                this.vehicleInfoHidden['driver']['costPerHour'] = (this.driverCost / Number(this.vehicleInfo.fuel.hours)).toFixed(2)
                this.driverCostHourly = (this.driverCost / Number(this.vehicleInfo.fuel.hours)).toFixed(2)


                localStorage.setItem('calculatorVehicleElectric', JSON.stringify(this.vehicleInfo))
                localStorage.setItem('calculatorVehicleDiesel', JSON.stringify(this.vehicleInfoHidden))

                let totalOtherCosts = Number(this.maintenanceCost) + Number(this.insuranceCost) + Number(this.taxesCost) + Number(this.tollsCost) + Number(this.driverCost)
                let totalOtherCostsHourly = (Number(this.maintenanceCostHourly) + Number(this.insuranceCostHourly) + Number(this.taxesCostHourly) + Number(this.tollsCostHourly) + Number(this.driverCostHourly)) * this.costElectric['hours']
                
                let costPerMileOutput = Number(totalOtherCosts) / Number(this.costElectric['mileage'])
                let costPerHourOutputOther = totalOtherCostsHourly / this.costElectric['hours']

                // Kick final calculations to storage so we can keep the value for use on later tabs.
                //TODO  In the future, we should leverage VueX for any sort of data management. Great in-app storage.
                sessionStorage.setItem('electricOtherCost', JSON.stringify({
                        'annual-cost': Number((totalOtherCosts).toFixed(2)), 
                        'annual-cost-hourly': Number((totalOtherCostsHourly).toFixed(2)), 
                        'cost-per-mile': Number((costPerMileOutput).toFixed(2)),
                        'cost-maintenance': Number(this.maintenanceCost),
                        'cost-insurance': Number(this.insuranceCost),
                        'cost-taxes': Number(this.taxesCost),
                        'cost-tolls': Number(this.tollsCost),
                        'cost-driver': Number(this.driverCost),
                        'cost-per-hour': Number((costPerHourOutputOther).toFixed(2)),
                        'cost-maintenance-hourly': Number(this.maintenanceCostHourly),
                        'cost-insurance-hourly': Number(this.insuranceCostHourly),
                        'cost-taxes-hourly': Number(this.taxesCostHourly),
                        'cost-tolls-hourly': Number(this.tollsCostHourly),
                        'cost-driver-hourly': Number(this.driverCostHourly),
                        'modified': this.modified
                    })
                )
                
                if (!this.costOtherDiesel['modified']) {
                    sessionStorage.setItem('dieselOtherCost', JSON.stringify({
                            'annual-cost': Number((totalOtherCosts).toFixed(2)), 
                            'annual-cost-hourly': Number((totalOtherCostsHourly).toFixed(2)), 
                            'cost-per-mile': Number((costPerMileOutput).toFixed(2)),
                            'cost-maintenance': Number(this.dCostMaintenance),
                            'cost-insurance': Number(this.insuranceCost),
                            'cost-taxes': Number(this.taxesCost),
                            'cost-tolls': Number(this.tollsCost),
                            'cost-driver': Number(this.driverCost),
                            'cost-per-hour': Number((costPerHourOutputOther).toFixed(2)),
                            'cost-maintenance-hourly': Number(this.maintenanceCostHourly),
                            'cost-insurance-hourly': Number(this.dCostMaintenanceHourly),
                            'cost-taxes-hourly': Number(this.taxesCostHourly),
                            'cost-tolls-hourly': Number(this.tollsCostHourly),
                            'cost-driver-hourly': Number(this.driverCostHourly),
                            'modified': this.modified,
                            'isMaintCostChange': this.isMaintCostChange,
                            'e-cost-maintenance': Number(this.maintenanceCost),
                            'e-cost-maintenance-hourly': Number(this.maintenanceCostHourly)
                        })
                    )
                }

                this.costOther = JSON.parse(sessionStorage.getItem('electricOtherCost'))

            },

            currencyToggle() {
                console.log(this.currentCurrency)
                if(this.currentCurrency == 'america') {
                    this.maintenanceCostHourly = (this.maintenanceCostHourly * this.usToCa).toFixed(2)
                    this.insuranceCostHourly = (this.insuranceCostHourly * this.usToCa).toFixed(2)
                    this.taxesCostHourly = (this.taxesCostHourly * this.usToCa).toFixed(2)
                    this.tollsCostHourly = (this.tollsCostHourly * this.usToCa).toFixed(2)
                    this.driverCostHourly = (this.driverCostHourly * this.usToCa).toFixed(2)

                    this.maintenanceCost =(this.maintenanceCost *this.usToCa).toFixed(2)
                    this.insuranceCost =(this.insuranceCost *this.usToCa).toFixed(2)
                    this.taxesCost =(this.taxesCost *this.usToCa).toFixed(2)
                    this.tollsCost =(this.tollsCost *this.usToCa).toFixed(2)
                    this.driverCost =(this.driverCost *this.usToCa).toFixed(2)
                    
                    this.currentCurrency = 'canada'
                    this.calculateTotals()
                } else {
                    this.maintenanceCostHourly = (this.maintenanceCostHourly / this.usToCa).toFixed(2)
                    this.insuranceCostHourly = (this.insuranceCostHourly / this.usToCa).toFixed(2)
                    this.taxesCostHourly = (this.taxesCostHourly / this.usToCa).toFixed(2)
                    this.tollsCostHourly = (this.tollsCostHourly / this.usToCa).toFixed(2)
                    this.driverCostHourly = (this.driverCostHourly / this.usToCa).toFixed(2)

                    this.maintenanceCost =(this.maintenanceCost / this.usToCa).toFixed(0)
                    this.insuranceCost =(this.insuranceCost / this.usToCa).toFixed(0)
                    this.taxesCost =(this.taxesCost / this.usToCa).toFixed(0)
                    this.tollsCost =(this.tollsCost / this.usToCa).toFixed(0)
                    this.driverCost =(this.driverCost / this.usToCa).toFixed(0)
                    
                    this.currentCurrency = 'america'
                    this.calculateTotals()
                }
            },
            
            // Sets Miles or Hours calculations based on selection in navigation
            setUsage(value) {
                (sessionStorage.getItem('usage') == null || sessionStorage.getItem('usage').length === 0) ? this.currentUsage = this.currentUsage : this.currentUsage = value
                this.calculateTotals()
            },

            formatInputMaintenanceCost() {
                this.maintenanceCostFormatted = this.maintenanceCostFormatted.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.maintenanceCost = Number(this.maintenanceCostFormatted.replace(/,/g, ''))
            },
            formatInputFromSliderMaintenanceCost() {
                this.maintenanceCostFormatted = Number(this.maintenanceCost).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            
            formatInputInsuranceCost() {
                this.insuranceCostFormatted = this.insuranceCostFormatted.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.insuranceCost = Number(this.insuranceCostFormatted.replace(/,/g, ''))
            },
            formatInputFromSliderInsuranceCost() {
                this.insuranceCostFormatted = Number(this.insuranceCost).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },

            formatInputTaxesCost() {
                this.taxesCostFormatted = this.taxesCostFormatted.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.taxesCost = Number(this.taxesCostFormatted.replace(/,/g, ''))
            },
            formatInputFromSliderTaxesCost() {
                this.taxesCostFormatted = Number(this.taxesCost).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            
            formatInputTollsCost() {
                this.tollsCostFormatted = this.tollsCostFormatted.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.tollsCost = Number(this.tollsCostFormatted.replace(/,/g, ''))
            },
            formatInputFromSliderTollsCost() {
                this.tollsCostFormatted = Number(this.tollsCost).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            
            formatInputDriverCost() {
                this.driverCostFormatted = this.driverCostFormatted.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                this.driverCost = Number(this.driverCostFormatted.replace(/,/g, ''))
            },
            formatInputFromSliderDriverCost() {
                this.driverCostFormatted = Number(this.driverCost).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },

            formatPrice(value, spaces = 2) {
                let val = (value/1).toFixed(spaces)
                return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            modify() {
                this.modified = true
            },
            trackViewSummary() {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - View Full Summary',
                    'event_label': 'End: ' + this.$route.path
                })
            },
            trackMaintenance(value) {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - Electric Other Cost',
                    'event_label': 'Maintenance ' + value
                })
            },
            trackInsurance(value) {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - Electric Other Cost',
                    'event_label': 'Insurance ' + value
                })
            },
            trackTaxes(value) {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - Electric Other Cost',
                    'event_label': 'Taxes ' + value
                })
            },
            trackTolls(value) {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - Electric Other Cost',
                    'event_label': 'Tolls ' + value
                })
            },
            trackDriver(value) {
                // Tracking
                window.gtag('event', 'Click', {
                    'event_category': 'Cost Calculator - Electric Other Cost',
                    'event_label': 'Driver ' + value
                })
            },
            independentCostAdjustment() {
                // set flag here so CalculateTotal will pull correct values
                if (!this.isMaintCostChangeClick) {
                    this.isMaintCostChange = true;
                    this.isMaintCostChangeClick = true;
                }
                // these are the variables to track.... for now
                // electricMaintenanceCostOutput
                // electricMaintenanceCost
            }
        }
    }
</script>